import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/houseDecorate/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/houseDecorate/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/houseDecorate/get',
    method: 'post',
    data: data
  });
} // 获取收费详情

export function fetchDecorationDetail(data) {
  return request({
    url: '/pmsservice/api/decorateBillAndPic/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/houseDecorate/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/houseDecorate/update',
    method: 'post',
    data: data
  });
}
export function fetchHouseDetail(data) {
  return request({
    url: '/pmsservice/api/houseDecorate/get',
    method: 'post',
    data: data
  });
}
export function fetchDecorateList(data) {
  return request({
    url: '/pmsservice/api/houseDecorate/decorateList',
    method: 'post',
    data: data
  });
}
export function fetchDecorateInsert(data) {
  return request({
    url: '/pmsservice/api/houseDecorate/decorateInsert',
    method: 'post',
    data: data
  });
}
export function fetchDecorateDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/houseDecorate/decorateDelete',
    method: 'post',
    data: data
  });
} // 获取附件列表

export function fetchFileList(data) {
  return request({
    url: '/pmsservice/api/decorateBillAndPic/fileList',
    method: 'post',
    data: data
  });
} // 添加附件

export function fetchFileAdd(data) {
  return request({
    url: '/pmsservice/api/decorateBillAndPic/fileInsertBatch',
    method: 'post',
    data: data
  });
} // 删除附件

export function fetchFileDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/decorateBillAndPic/fileDelete',
    method: 'post',
    data: data
  });
}
export function fetchCheckList(data) {
  return request({
    url: '/pmsservice/api/decorateBillAndPic/list',
    method: 'post',
    data: data
  });
}
export function fetchChargeInsert(data) {
  return request({
    url: '/pmsservice/api/decorateBillAndPic/insertBatch',
    method: 'post',
    data: data
  });
}
export function fetchBindList(data) {
  return request({
    url: '/pmsservice/api/chargeResource/standardList',
    method: 'post',
    data: data
  });
} // 完成装修

export function zxOk(data) {
  return request({
    url: '/pmsservice/api/houseDecorate/finishFlag',
    method: 'post',
    data: data
  });
}